import type { ExportRecordFieldApiProps, ExportRecordFieldFormat } from '../../@types/records';
import { recordApi } from '../../redux/services/record';
import { appDispatch } from '../../redux/store-accessors';
import { ExportBackgroundJobHandler } from './export-background-job.handler';

export class ExportRecordFieldBackgroundJobHandler extends ExportBackgroundJobHandler<ExportRecordFieldApiProps> {
  fileName: string;

  constructor(apiProps: ExportRecordFieldApiProps, details?: Record<string, unknown>) {
    const fileName = `${apiProps.recordId}${getFileExtension(apiProps.format)}`;

    super(apiProps, { ...details, fileName });
    this.fileName = fileName;
  }

  protected dispatchCreateJob() {
    return appDispatch(
      recordApi.endpoints.createRecordFieldExportJob.initiate({
        fieldId: this.apiProps.fieldId,
        recordId: this.apiProps.recordId,
        format: this.apiProps.format,
      })
    ).unwrap();
  }

  protected getDownloadFileName(response: Record<string, string>): string {
    return this.fileName ?? response.fileName;
  }
}

// util
const getFileExtension = (format: ExportRecordFieldFormat) => {
  if (format === 'PDF_EXPORT') {
    return '.pdf';
  } else if (format === 'WORD_EXPORT') {
    return '.docx';
  } else {
    return '';
  }
};
